











































































































































































































































import {

  ColorsList,
  formatDate,
    formatList,
    getIndexFromList, isNullOrEmpty
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Input from '../../core/components/Input.vue';
import LabelWithValue from '../../core/components/LabelWithValue.vue';
import {
    MsgBox,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { NormsServices } from '../api/NormsServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import Button from '../../core/components/Button.vue';
import { DtcAck } from '../../reempujon/models/Reempujon';
import { ReempujonServices } from '../../reempujon/api/ReempujonServices';
import BtnMenuWithOptions from '../../core/components/BtnMenuWithOptions.vue';
import { OptionBtnWithMenu } from '../../core/models/util-models';
@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        PlusEyeButtons,
        Breadcrums,
        CloseConfirmationModal,
        Input,
        Button,
        LabelWithValue,
        BtnMenuWithOptions
    }
})
export default class CreateDTC extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() typeOfDataOptions: any;
    @Prop() printingTypeOptions: any;
    @Prop() endiannessTypeOptions: any;
    @Prop() visibleFrameFromList: any;
    @Prop({default: false}) isReempujon: boolean;

    @Prop() patchData: any;
    @Prop() editing: boolean;
    @Prop() protocolOptions: any;
    @Prop() classifications: any;
    @Prop({default(){return []}}) brandOptions: Array<object>

    visibleCloseConfirmationModal: boolean = false;
    visibleModalCreateDTC: boolean = false;
    description: string = '';
    pendingRequest: boolean = false;
    submitButtonText: string = '';
    modalTitle: string = '';
    commentary: string = '';
    ecuField: string = '';
    dateFormat: Function = formatDate;
    allActions: OptionBtnWithMenu[] = [
        { 
            value: 0, 
            text: 'Marcar como vista sólo esta falla', 
            type: 'button',
            url: '',
            loading: false,
            action: this.markDtcAsSeen,
            tooltip: 'Se marcará como vista sólamente esta falla para éste vehículo',
            disabled: null,
            color: 'info',
        },
        { 
            value: 1, 
            text: 'Desmarcar como vista sólo esta falla', 
            type: 'button',
            url: '',
            loading: false,
            action: this.markDtcAsUnSeen,
            tooltip: 'Se marcará como NO vista sólamente esta falla para éste vehículo',
            disabled: null,
            color: 'info', 
        },
        { 
            value: 2, 
            text: 'Marcar como vistas todas las mismas fallas', 
            type: 'button',
            url: '',
            loading: false,
            action: this.markAllPreviousDTCsAsSeen,
            tooltip: `Se marcarán como Vistas todas las fallas con Código DTC `,
            disabled: null,
            color: 'error',
        },
        { 
            value: 3, 
            text: 'Marcar como NO vistas todas las mismas fallas', 
            type: 'button',
            url: '',
            loading: false,
            action: this.unMarkAllPreviousDTCsAsSeen,
            tooltip: 'Se marcarán como NO vistas todas las fallas con Código DTC ',
            disabled: null,
            color: ColorsList.orange,
        }
    ];
    actions: OptionBtnWithMenu[] = [];

    updateVisibleActions(){
        let dtcCode = this.patchData['dtc'];
        let currentDtcIsViewed = this.ackInfo['ack'];
        let actions = this.allActions.map(action => {
            //agrego el dtcCode al tooltip para las acciones 2 y 3
            if(action['value'] == 2 || action['value'] == 3){
                action['tooltip'] += `(${dtcCode}) hasta la fecha de la falla para éste vehículo`
            }            
            return action;
        })

        if(currentDtcIsViewed){
            //si el dtc actual está visto, no se puede marcar como visto
            actions = actions.filter(action => action['value'] !== 0);
        }else{
            //si el dtc actual no está visto, no se puede marcar como no visto
            actions = actions.filter(action => action['value'] !== 1);
        }
        this.actions = actions;
    }

    parseList(value){
        return value.join(', ');
    }


    booleanOptions: any = [
        {
            value: true,
            description: 'true'
        },
        {
            value: false,
            description: 'false'
        }
    ];
    dtcCode: any = 0;
    //select options
    protocolSelected: string = '';
    classificationSelected: any | null = null;

    //select reset value
    protocolRV: boolean = false;
    classificationRV: boolean = false;

    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;

    brandSelected:any | null = null;
    brandSelectedRV:boolean = false;
    markDtcSingle: boolean = false;
    markDtcAll: boolean = false;
    ackInfo: any = null;


    markDtcAsUnSeen(){
        // console.log("markDtcAsUnSeen");
        let params: DtcAck = {
            id: this.patchData['id'],
            ack: false,
            ack_all: false
        }
        this.markDtcSingle = true;
        this.markDtcAsSeenAction(params);
    }

    markDtcAsSeen(){
        // console.log("markDtcAsSeen");
        let params: DtcAck = {
            id: this.patchData['id'],
            ack: true,
            ack_all: false
        }
        this.markDtcSingle = true;
        this.markDtcAsSeenAction(params);
    }

    unMarkAllPreviousDTCsAsSeen(){
        let params: DtcAck = {
            id: this.patchData['id'],
            ack: false,
            ack_all: true
        }
        this.markDtcAll = true;
        this.markDtcAsSeenAction(params);
    }

    markAllPreviousDTCsAsSeen(){
        let params: DtcAck = {
            id: this.patchData['id'],
            ack: true,
            ack_all: true
        }
        this.markDtcAll = true;
        this.markDtcAsSeenAction(params);
    }


    markDtcAsSeenAction(params: DtcAck){
        //guardo cambios en el formulario antes de marcar como visto
        this.triggerSubmit(); 

        //marco como visto
        ReempujonServices.markDtcAck(
            params
        ).then(response => {
            this.refreshDtcs();
            this.closeModal();
            this.updateVisibleActions();
        }).catch(error => {
            this.$_catchLoadingDialog({
                response: error.response.data || {},
                alternative_msg: 'No se pudo marcar como visto'
            });
        }).finally(() => {
            this.markDtcSingle = false;
            this.markDtcAll = false;
        });
    }

    @Emit()
    updateDtcAck(ack, dtcId){}

    @Emit()
    refreshDtcs(){

    }

    updateBrandSelected(option){
        this.brandSelected = option
    }
    updateBrandSelectedRV(value){
        this.brandSelectedRV = value
    }

    //Breadcrums
    breadcrumsItems: any = [];

    updateDtcDescription(value){
        this.description = value;
    }
    updateDtcCode(value){
        this.dtcCode = value;
    }
    updateEcuField(value){
        this.ecuField = value;
    }

    //methods
    mounted() {
        this.handleListenKey(true);
        this.visibleModalCreateDTC = this.visible;

        if (this.editing) {
            this.submitButtonText = 'Guardar Cambios';
            this.modalTitle = 'Modificar DTC' + ' <b> - ' + this.patchData['description'] + '</b>';
            this.loadPatchData();
        } else {
            this.submitButtonText = 'Crear DTC';
            this.modalTitle = 'Crear DTC';
        }
    }

    getBrandForCombobox(brand){
        let indexBrandInOptions = getIndexFromList(this.brandOptions, 'id', brand)
        if (indexBrandInOptions !== -1) {
            return this.brandOptions[indexBrandInOptions];
        }else{
            return null;
        }
    }

    loadPatchData() {
        this.description = this.patchData['description'];
        this.dtcCode = this.patchData['dtc'];

        if(!isNullOrEmpty(this.patchData['commentary'])){
            this.commentary = this.patchData['commentary']['text'];
        }
        
        this.ecuField = this.patchData['ecu'];
        
        let indexClassificationInOptions = getIndexFromList(this.classifications, 'id', this.patchData['classification']['id']) 

        this.protocolSelected = this.patchData['protocol'];
        if (indexClassificationInOptions !== -1) {
            this.classificationSelected = this.classifications[indexClassificationInOptions];
        }
        if(this.isReempujon){
            if(!this.patchData['ack']){
                this.ackInfo = {
                    ack: false,
                    ack_timestamp: null,
                    ack_username: null
                }
            }else{
                this.ackInfo = {
                    ack: this.patchData['ack'],
                    ack_timestamp: this.patchData['ack_timestamp'],
                    ack_username: this.patchData['ack_username']
                }
            }
            
        }
        this.updateBrandSelected(this.getBrandForCombobox(this.patchData['brand']));
        this.updateVisibleActions();
    }

    updateProtocolSelected(option) {
        this.protocolSelected = option;
    }

    updateClassificationSelected(option) {
        this.classificationSelected = option;
    }

    updateClassificationResetValue(value) {
        this.classificationSelected = value;
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.handleListenKey(false);
        this.visibilityCloseConfirmationModal(false);
    }

    showCloseConfirmationModal() {
        this.visibilityCloseConfirmationModal(true);
    }

    visibilityCloseConfirmationModal(value) {
        this.visibleCloseConfirmationModal = value;
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    triggerSubmit() {
        let self = this;
        if(this.checkIfFormIsValid){
            this.pendingRequest = true;

            let configuration = this.getData();
            if (!this.editing) {
                this.$_showLoadingDialog('Generando DTC...');
                NormsServices.postCreateDTC(configuration)
                    .then(response => {
                        this.$_successLoadingDialog({
                            response: response,
                            alternative_msg: 'DTC creado con éxito'
                        })
                        self.closeModal();
                        this.pendingRequest = false;
                        let dtcToAdd = response['dtc'];
                        dtcToAdd['protocol'] = self.protocolSelected;
                        dtcToAdd['classification'] = self.classificationSelected;
                        self.$emit('add-new-dtc', response['dtc']);
                    })
                    .catch(error => {
                        this.pendingRequest = false;
                        this.$_catchLoadingDialog({
                            response: error.response.data || {},
                            alternative_msg: 'Ocurrio un error al crear DTC'
                        });
                    });
            } else {
                this.$_showLoadingDialog('Modificando DTC...');
                let dtcId = this.isReempujon ? this.patchData['dtc_id'] : this.patchData['id']
                NormsServices.patchDTC(configuration, dtcId)
                    .then(response => {
                        this.$_successLoadingDialog({
                            response: response.data,
                            alternative_msg: 'DTC Modificado con éxito',
                        })
                            self.pendingRequest = false;
                            self.closeModal();
                            self.refreshDtcs();
                    })
                    .catch(error => {
                        this.pendingRequest = false;
                        this.$_catchLoadingDialog({
                            response: error.response.data || {},
                            alternative_msg: 'No se pudo modificar el DTC'
                        });
                    })
            }
        }
    }




    getData() {
        return {
            description: this.description,
            classification: this.classificationSelected['id'],
            protocol: this.protocolSelected,
            dtc: this.dtcCode,
            brand: Number(this.brandSelected['id']),
            commentary: this.commentary,
            ecu: this.ecuField
        };
    }

    get checkIfFormIsValid() {
        if (this.description === '') {
            return false;
        }

        if(this.brandSelected == null){
            return false;
        }

        if (isNullOrEmpty(this.protocolSelected)) {
            return false;
        }

        if (this.dtcCode === '') {
            return false;
        }

        if (this.classificationSelected == null) {
            return false;
        }

        return true;
    }


    getFinalizationValue(finalization) {
        if (finalization !== null) {
            if (finalization['id'] !== -1) {
                return finalization['id'];
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    getInitializationValue(initialization) {
        if (initialization !== null) {
            if (initialization['id'] !== -1) {
                return initialization;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }
}
